module.exports = __webpack_public_path__ + "img/ennetix-users-tab3.36755790.png";